import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { MediumTypeComboBoxComponent } from './medium-type-combo-box.component';

/**
 * 媒体区分コンボボックスモデル
 *
 * @export MediumTypeComboBoxModel
 * @class MediumTypeComboBoxModel
 */
export class MediumTypeComboBoxModel {

  /**
   * 媒体区分リスト
   */
  public mediumList: Array<any> = new Array<any>();
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // 先頭空白表示
  public allMediumType: boolean = <boolean>false;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setMediumType: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // オーダーコード(voの値)
  public orderCode: string = <string>'';
  // コンボボックスインスタンス
  public component: MediumTypeComboBoxComponent;


  /**
   * 媒体区分リストを更新する
   *
   * @param {*} serverData 媒体区分リスト取得データ
   * @returns {void}
   * @memberof MediumTypeComboBoxModel
   */
  public updateMediumList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
        const ob: any = {};
        ob.MediumType = '';
        ob.MediumName = '';
        ob.MediumTypeName = '';
        ob.ProgressWorkNum = '';
        ob.ProgressWorkName = '';
        ob.StopOrderCode = '';
        tempDataList.splice(index, 0, ob);
        index = <number>1;
    }

    // 全媒体
    if (this.allMediumType) {
        const ob2: any = {};
        ob2.MediumType = '';
        ob2.MediumName = '全媒体';
        ob2.MediumTypeName = '*:全媒体';
        ob2.ProgressWorkNum = '';
        ob2.ProgressWorkName = '';
        ob2.StopOrderCode = '';
        tempDataList.splice(index, 0, ob2);
        index += 1;
    }

    // コード+：+名称追加
    for (; index < tempDataList.length; index++) {
        tempDataList[index].MediumTypeName = tempDataList[index].MediumType + ':' + tempDataList[index].MediumName;
    }

    this.mediumList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedMediumType();
  }

}
